import React from 'react';
import logo_white from '../assets/images/logo-dark.svg';
import app from '../assets/images/app.png';
import playstore from '../assets/images/playstore.png';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'react-feather';
import { FaLinkedin } from 'react-icons/fa';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { AiOutlineInstagram, AiOutlineShoppingCart, AiOutlineTwitter } from 'react-icons/ai';
import { FiDribbble } from 'react-icons/fi';
import { BiLogoBehance } from 'react-icons/bi';
import { LiaFacebookF } from 'react-icons/lia';
import {Lock, ShieldCheck} from "lucide-react"


export default function Footer() {
    return (
        <footer className="footer bg-dark-footer relative text-gray-200 dark:text-gray-200 mt-24">
            <div className="container">
                <div className="grid grid-cols-1">
                    <div className="relative py-16">
                        <div className="relative w-full">
                            <div className="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
                                <div className="lg:col-span-4 md:col-span-12">
                                    <Link to="#" className="text-[22px] focus:outline-none">
                                        <img src={logo_white} alt="" />
                                    </Link>
                                    <p className="mt-6 text-gray-300">We are a leading store dedicated to connect the top artists with NFT art collectors!</p>

                                </div>

                                <div className="lg:col-span-2 md:col-span-4">
                                    <h5 className="tracking-[1px] text-lg text-gray-100 font-semibold">NIFTY</h5>
                                    <ul className="list-none footer-list mt-6">
                                        <li><Link to="/explore-one" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Explore Item</Link></li>
                                        <li className="mt-[10px]"><Link to="/wallet" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Wallet</Link></li>
                                        <li className="mt-[10px]"><Link to="/creators" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Creators</Link></li>
                                    </ul>
                                </div>

                                <div className="lg:col-span-3 md:col-span-4">
                                    <h5 className="tracking-[1px] text-lg text-gray-100 font-semibold">Usefull Links</h5>
                                    <ul className="list-none footer-list mt-6">
                                        <li className="mt-[10px]"><Link to="/terms" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Terms & Conditions</Link></li>
                                        <li className="mt-[10px]"><Link to="/privacy" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Cookie & Privacy policy</Link></li>
                                        <li className="mt-[10px]"><Link to="/contact" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Contact Us</Link></li>
                                        <li className="mt-[10px]"><Link to="/cookiepolicy" className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out inline-flex items-center"><MdKeyboardArrowRight className="me-1 text-lg"/> Cookie Declaration</Link></li>
                                    </ul>
                                </div>

                                <div className="lg:col-span-3 md:col-span-4">
                                    <div className="mt-0">
                                      <h5 className="tracking-[1px] text-lg text-gray-100 font-semibold">
                                        Contact Details
                                      </h5>
                                    
                                      <div className="mt-3 space-y-3">
                                        {/* Email */}
                                        <div className="flex items-center">
                                          <Mail className="size-5 text-violet-600 me-3" />
                                          <a
                                            href="mailto:info@nifty-art.com"
                                            className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                                          >
                                            info@nifty-art.com
                                          </a>
                                        </div>
                                    
                                        {/* Phone */}
                                        <div className="flex items-center">
                                          <Phone className="size-5 text-violet-600 me-3" />
                                          <a
                                            href="tel:+447893926971"
                                            className="text-[16px] text-gray-300 hover:text-gray-400 duration-500 ease-in-out"
                                          >
                                            +44 7893 926971
                                          </a>
                                        </div>
                                      </div>


                                
                                    {/* Данные компании */}
                                    <div className="mt-6">
                                      <h5 className="tracking-[1px] text-lg text-gray-100 font-semibold">Company Details</h5>
                                      <p className="text-[16px] text-gray-300">JADEFIRST LIMITED</p>
                                      <p className="text-[16px] text-gray-300">
                                        No. 15932126
                                      </p>
                                      <p className="text-[16px] text-gray-300">
                                        Registration address: 72 Halliwick Road, London, England, N10 1AB
                                      </p>
                                      <p className="text-[16px] text-gray-300">
                                        Copyright © 2026. All Rights Reserved.
                                      </p>
                                    </div>
                                
                                    {/* Иконки оплаты */}
                                    <div className="mt-6 flex items-center gap-4">
                                      <img
                                        src={require('../assets/images/visa.png')}
                                        alt="Visa"
                                        className="w-12 h-auto"
                                      />
                                      <img
                                        src={require('../assets/images/mastercard.png')}
                                        alt="Mastercard"
                                        className="w-12 h-auto"
                                      />
                                    </div>
                                    <div className='flex items-center gap-2 text-[11px] md:text-xs'>
                                        <Lock className='h-4 w-4 text-white' />
                                        <span>Secure Payment</span>
                                    </div>
                                    <div className='flex items-center gap-2 text-[11px] md:text-xs'>
                                        <ShieldCheck className='h-4 w-4 text-white' />
                                        <span>PCI DSS Compliant</span>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
